class IntraSectionItem {
  constructor(params) {
    this.order = params.order;
    this.link = params.link;
    this.title = params.title;
    this.titleColor = params.titleColor;
    this.description = params.description;
    this.descriptionColor = params.descriptionColor;
  }
}

export { IntraSectionItem };



// WEBPACK FOOTER //
// ./src/models/IntraSectionItem.js